import moment from 'moment';
import zxcvbn from 'zxcvbn';
import confirmModal from '../../../common/modals/ConfirmModal/confirmModal.component';
import leaveBenefitModal from '../../../common/modals/leaveBenefitModal/leaveBenefitModal.component';
import compensationChangeModal from '../../../common/modals/compensationChangeModal/compensationChangeModal.component';

import formatCurrency from "format-currency";

class EmployeeDetailsController {

  constructor(AuthenticationService, CompanyService, toastr, $scope, $http, $rootScope, $stateParams, $state, $uibModal) {
    "ngInject";
    this.auth = AuthenticationService;
    this.moment = moment;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    let self = this;
    this.users = [];
    this.$uibModal = $uibModal;
    this.activeUsers = [];
    this.availableBenefitTypes = [];

    this.$http.get(self.$rootScope.apiHost+'/api/admin/users/?active=true', {withCredentials: true}).then(function (success) {
      self.activeUsers = success.data;
    });

    self.userTypes = [
      {value: 'fullTime', text: 'Full Time'},
      {value: 'hourly', text: 'Hourly'},
      {value: 'contractor', text: 'Contractor'},
      {value: 'subcontractor', text: 'Subcontractor'}
    ];

    if($stateParams.employeeId) {
      this.$http.get($rootScope.apiHost+"/api/admin/users/"+$stateParams.employeeId, {withCredentials: true}).then(function (success) {
        self.employee = success.data;
        self.employee.startDate = moment(self.employee.startDate).toDate();
        if(self.employee.userLeave && self.employee.userLeave.length > 0) {
          self.activeLeave = self.employee.userLeave[0].id;
        }
      },
      function (failure) {
        $state.go("notfound");
      });

      this.$http.get($rootScope.apiHost+"/api/admin/users/"+$stateParams.employeeId+"/profitability", {withCredentials: true}).then(function (success) {
          self.employeeProfitability = success.data;
      });


      this.$http.get($rootScope.apiHost+"/api/admin/users/", {withCredentials: true}).then(function (success) {
        self.users = success.data;
      });

      this.$http.get($rootScope.apiHost+"/api/admin/roles", {withCredentials: true}).then(function (success) {
        self.roles = success.data;
      });

      this.$http.get($rootScope.apiHost+"/api/admin/users/"+$stateParams.employeeId+"/earnings", {withCredentials: true}).then(function (success) {
        self.earnings = success.data;
      });

      self.leaveTypes = [];
      this.$http.get($rootScope.apiHost+"/api/leave/types", {withCredentials: true}).then(function (success) {
        self.leaveTypes = success.data;
      });

      self.chargeCodes = [];
      this.$http.get($rootScope.apiHost+"/api/admin/chargecodes", {withCredentials: true}).then(function (success) {
        self.chargeCodes = success.data;
      });


      self.availableBenefits = [];
      this.$http.get($rootScope.apiHost+"/api/admin/companies/1/benefits", {withCredentials: true}).then(function (success) {
        self.availableBenefits = success.data;

        self.availableBenefits.forEach(function (benefit) {
          self.availableBenefitTypes.push(benefit.type);
        });

        self.availableBenefitTypes = _.uniq(self.availableBenefitTypes);

      });


    } else {
      $state.go("notfound");
    }

    this.opened = {};

    this.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      self.opened[elementOpened] = !self.opened[elementOpened];
    };


  }

  addBenefitToUser() {
    // console.log(this.currentlySelectedBenefit);
    // console.log(this.employee.id);

    this.$http.post(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/benefits/"+this.currentlySelectedBenefit, {}, {withCredentials: true}).then(function (success) {
      // self.availableBenefits = success.data;
    });


  }


  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      phoneNumberString = '(' + match[1] + ') ' + match[2] + '-' + match[3]
      return true;
    }

    return false;
  }

  refreshEmployeeData() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id, {withCredentials: true}).then(function (success) {
        self.employee = success.data;
        self.getUserLeave();
      },
      function (failure) {
        $state.go("notfound");
      });
  }


  getAnnualSalaryForHourlyEmployee() {
    if(this.employee) {
      let x = this.employee.hourlyRate * this.employee.targetHours;
      return this.currency(x);
    }
  }

  updateRole(role) {
    this.updateUserDetails("roles", role);
  }


  getTotalEarningsForYear(earning) {
    return this.currency((earning.REG || 0) + (earning.RETRO || 0) + (earning.BONUS || 0) + (earning.other || 0));
  }


  getManager() {
    let value = '';
    let self = this;
    if(self.employee) {
      this.users.forEach(function (user) {
        if (user.id == self.employee.manager) {
          value = (user.firstName + " " + user.lastName);
        }
      });
    }

    return value;
  }

  currency(value) {
    return formatCurrency(value);
  }


  getUserType() {
    let value = '';
    let self = this;
    if(self.employee) {
      this.userTypes.forEach(function (userType) {
        if (userType.value == self.employee.userType) {
          value = userType.text;
        }
      });
    }

    return value;
  };


  confirmCompensationChange() {
    let self = this;
    var modalInstance = this.$uibModal.open(compensationChangeModal);
    modalInstance.employeeType  = this.employee.userType;
    modalInstance.annualSalary = this.employee.annualSalary;
    modalInstance.hourlyRate = this.employee.hourlyRate;
    modalInstance.targetHours = this.employee.targetHours;
    modalInstance.employeeId = this.employee.id;


    modalInstance.success = function () {
      self.toastr.success("Update Success", "SUCCESS");
      if(self.employee.userType == 'fullTime') {
        self.employee.annualSalary = modalInstance.annualSalary;
      } else {
        self.employee.hourlyRate = modalInstance.hourlyRate;
        self.employee.targetHours = modalInstance.targetHours;
      }

      self.$http.get(self.$rootScope.apiHost+"/api/admin/users/"+self.employee.id, {withCredentials: true}).then(function (s) {
        self.employee = s.data;
        self.employee.startDate = moment(self.employee.startDate).toDate();
        self.employee.terminationDate = moment(self.employee.terminationDate).toDate();

        if(self.employee.userLeave && self.employee.userLeave.length > 0) {
          self.activeLeave = self.employee.userLeave[0].id;
        }
      });


      modalInstance.dismiss();
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };

  }

  confirmDirectAnnualBenefitChange(userLeave) {
    let self = this;
    var modalInstance = this.$uibModal.open(leaveBenefitModal);
    modalInstance.annualBenefit = userLeave.annualBenefit;
    modalInstance.effectiveDate = userLeave.effectiveDate;
    modalInstance.leaveId = userLeave.id;
    modalInstance.employeeId = this.employee.id;


    modalInstance.success = function () {
      self.toastr.success("Update Success", "SUCCESS");
      userLeave.annualBenefit = modalInstance.annualBenefit;
      userLeave.effectiveDate = modalInstance.effectiveDate;
      modalInstance.dismiss();
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

  setReferringEmployee(employee) {
    this.updateUserDetails('referringEmployee', employee.id);
  }

  addLeaveToUser(leaveType) {
    let self = this;
    this.$http.patch(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/leave", leaveType, {withCredentials: true}).then(function (success) {
      self.employee = success.data;
      self.activeLeave = self.employee.userLeave[0].id;
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });
  }

  availableLeaveTypes() {
    let availableLeave = [];
    let self = this;
    if(self.employee) {
      this.leaveTypes.forEach(function (leaveType) {
        let idx = _.findIndex(self.employee.userLeave, function (l) {
          return l.type === leaveType.name;
        });

        if (idx < 0) {
          availableLeave.push(leaveType);
        }
      });
    }

    return availableLeave;
  }

  hasRole(role) {

    let self = this;
    let value = false;
    if(self.employee){
      self.employee.roles.forEach(function (r) {
        if(r.roleName === role) {
          value = true;
        }
      });
    }
    return value;
  }

  getStartDate() {
    if(this.employee) {
      return moment(this.employee.startDate).format("MMM DD, YYYY");
    }
  }

  getTerminationDate() {
    if(this.employee) {
      return moment(this.employee.terminationDate).format("MMM DD, YYYY");
    }
  }


  formatDate(date) {
    return moment(date).format("MM-DD-YYYY");
  }

  showRoles() {
    var selected = [];

    if(this.employee) {
      this.employee.roles.forEach(function (role) {
        selected.push(role.roleName);
      });
    }

    return selected.length ? selected.join(', ') : 'Not set';
  };

  disableCheckbox(v) {
    console.log(v);
    if (this.employee.roles.indexOf(v) === -1) {
      return true;
    }
    return false;
  }

  updateUser(data) {
    console.log(data);
  }

  updateUserLeave(leaveId, parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/userleave/"+leaveId, obj, {withCredentials: true}).then(function (success) {
      // self.employee = success.data;
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });

  }

  updateLeaveAdjustment(leaveId, adjustmentId, parameter, value) {
    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/userleave/"+leaveId+"/adjustments/"+adjustmentId, obj, {withCredentials: true}).then(function (success) {
      // self.employee = success.data;
      self.toastr.success("Leave Adjustment Updated.", "Success!");
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });

  }


  addLeaveAdjustment(leaveId) {
    let self = this;
    let obj = {
      leaveAdjustmentDate: this.leaveAdjustmentDate,
      leaveAdjustmentHours: this.leaveAdjustmentHours,
      leaveAdjustmentReason: this.leaveAdjustmentReason
    };

    this.$http.post(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/userleave/"+leaveId+"/adjustments", obj, {withCredentials: true}).then(function (success) {
      // self.employee = success.data;
      self.toastr.success("Leave Adjustment Added.", "Success!");
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });
  }

  removeLeaveAdjustment(leaveId, adjustmentId) {
    let self = this;
    this.$http.delete(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/userleave/"+leaveId+"/adjustments/"+adjustmentId, {withCredentials: true}).then(function (success) {
      // self.employee = success.data;
      self.toastr.success("Leave Adjustment Removed.", "Success");
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });
  }

  userActiveToggle() {
    this.updateUserDetails("active", this.employee.active);
  }

  trackLeaveToggle(){
    this.updateUserDetails("trackLeave", this.employee.trackLeave);
  }

randomResetPassword() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/password-reset", {withCredentials: true}).then(function (success) {
      self.toastr.success("User successfully updated.", "Success");
    }, function (failure) {
           self.toastr.error("Could not update user.", "ERROR");
    });
 }

  updateUserDetails(parameter, value) {

    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id, obj, {withCredentials: true}).then(function (success) {
      // self.employee = success.data;
      self.toastr.success("User successfully updated.", "Success");
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });
  }

  getUserLeave() {
    if(this.employee) {
      return this.employee.userLeave;
    }
  }

  updateUserSalaryHistory(id, parameter, value){
    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/salaryhistory/"+id, obj, {withCredentials: true}).then(function (success) {
      self.toastr.success("User successfully updated.", "Success");
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });
  }


  addChargeCodeToUser(item) {
    let self = this;

    this.$http.post(this.$rootScope.apiHost+"/api/admin/chargecodes/"+item.id+"/users/"+this.employee.id, {}, {withCredentials: true}).then(function (success) {
      self.toastr.success("Charge Code Added For Employee.", "Success");
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });
  }

  removeChargeCodeFromEmployee(chargeCode) {
    let self = this;

    this.$http.delete(this.$rootScope.apiHost+"/api/admin/chargecodes/"+chargeCode.id+"/users/"+this.employee.id, {withCredentials: true}).then(function (success) {
      self.refreshEmployeeData();


      self.toastr.success("Charge Code Removed For Employee.", "Success");
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });
  }

  getAvailableChargeCodes() {
    let self = this;
    let result = [];

    result = _.filter(this.chargeCodes, function (chargeCode) {
      let found = false;

      self.employee.availableChargeCodes.forEach(function (cc) {
        if(chargeCode.id == cc.id) {
          found = true;
        }
      });

      return !found;
    });


    return result;
  }

  updateMaxHoursForChargeCode(chargeCodeId, userMaxHours) {
    let self = this;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/chargecodes/"+chargeCodeId+"/users/"+this.employee.id, {userMaxHours: userMaxHours}, {withCredentials: true}).then(function (success) {
      self.toastr.success("Max Hours Updated For Employee.", "Success");
      self.refreshEmployeeData();
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });
  }


  syncEmployeeWithPaylocity() {
    let self = this;
    this.$http.get(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/paylocitysync", {withCredentials: true}).then(function (success) {
      self.employee = success.data;
    });
  }

  removeSalaryHistory(salaryHistory) {
    let self = this;
    this.$http.delete(this.$rootScope.apiHost+"/api/admin/users/"+this.employee.id+"/salaryhistory/"+salaryHistory.id, {withCredentials: true}).then(function (success) {
      self.employee = success.data;
    });
  }

}

export default EmployeeDetailsController;



// WEBPACK FOOTER //
// ./client/pages/admin/employee-details/employee-details.controller.js